import { Link, createFileRoute } from '@tanstack/react-router';
import { EmptyState, buttonVariants } from '@wundo/ui';

/*
 * Human-readable copy for the auth/OAuth failures better-auth redirects here
 * with. Public: whoever lands here has no session, which is the whole point.
 */
const MESSAGES: Record<string, string> = {
  email_does_not_match:
    'That account uses a different email than your Wundo login. Connect the account that matches, or ask an admin to allow linking different emails.',
  unable_to_link_account:
    "We couldn't link that account. Please try connecting it again.",
  access_denied:
    "You didn't grant access, so nothing was connected. You can try again whenever you're ready.",
  invalid_code: 'The sign-in link expired or was already used. Please try again.',
  unable_to_get_user_info:
    "We couldn't read your account details from the provider. Please try again.",
};

const FALLBACK = 'Something went wrong while connecting your account. Please try again.';

export const Route = createFileRoute('/auth/error')({
  validateSearch: (search: Record<string, unknown>) => ({
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: AuthErrorPage,
});

/** better-auth sends the raw code in the `error` query param; it is normalised to a key. */
export function messageForError(code: string | undefined): string {
  if (!code) return FALLBACK;

  return MESSAGES[code.replace(/[^a-z_]/gi, '_').toLowerCase()] ?? FALLBACK;
}

function AuthErrorPage() {
  const { error } = Route.useSearch();

  return (
    <main className='flex h-dvh items-center justify-center px-7'>
      <EmptyState
        title="Couldn't connect your account"
        description={messageForError(error)}
        action={
          <Link to='/' className={buttonVariants({ variant: 'accent' })}>
            Go to the start page
          </Link>
        }
      />
    </main>
  );
}
